<nes-dialog
  nes-id="someidtoo"
  [active]="isRouteDialogActive$ | async"
  (nesOnCloseClick)="closeDialog()"
>
  <div slot="content">
    <h2 class="route-dialog-title">{{ 'COMPOSE.ROUTE.TITLE' | translate }}</h2>
    <p class="route-dialog-subtext">{{ 'COMPOSE.ROUTE.DESCRIPTION' | translate }}</p>
    <div [formGroup]="formGroup">
      <bca-choose-station
        [cypress]="'from_station'"
        [searchFn]="searchStation"
        [label]="'COMPOSE.ROUTE.FROM.LABEL' | translate"
        [stationsLoading]="stationsLoading$ | async"
        [routeLoading]="routeLoading$ | async"
        [requiredError]="hasControlError('from', 'required')"
        [selectedStation]="(configuredRoute$ | async)?.from"
        (selected)="onFromStationSelected($event)"
      >
      </bca-choose-station>
      <bca-choose-station
        [cypress]="'to_station'"
        [searchFn]="searchStation"
        [label]="'COMPOSE.ROUTE.TO.LABEL' | translate"
        [stationsLoading]="stationsLoading$ | async"
        [routeLoading]="routeLoading$ | async"
        [requiredError]="hasControlError('to', 'required')"
        [selectedStation]="(configuredRoute$ | async)?.to"
        (selected)="onToStationSelected($event)"
      >
      </bca-choose-station>
      @if (routeLoading$ | async) {
        <div class="basicLoader"></div>
      } @else {
        <div class="nes-mt-6">
          <bca-route-summary
            [secondClassPrice]="((configuredRoute$ | async)?.price)?.[TravelerClass.SECOND] ?? 0"
            [trainFreePrice]="trainFreePrice$ | async"
          >
          </bca-route-summary>
        </div>
      }
    </div>
    @if (checkIdenticalError() !== undefined) {
      <nes-error-message>
        {{ "COMPOSE.ROUTE.ERROR.IDENTICAL" | translate }}
      </nes-error-message>
    }
    @if (showRouteValidationError && !formGroup.valid) {
      <div class="route-validation-error">
        <div class="route-validation-error__left-bar"></div>
        <div class="route-validation-error__content">
          <div class="route-validation-error__title">
            <nes-icon name="alert-thick-filled" class="route-validation-error__icon"></nes-icon>
            Niet alles is ingevuld
          </div>
          <div class="route-validation-error__subtitle">
            Vul de gegevens die missen in om verder te gaan.
          </div>
        </div>
      </div>
    }
  </div>

  <div class="nes-flex nes-justify-start" slot="button-group-footer">
    <nes-button
      [disabled]="routeLoading$ | async"
      [cypress]="'dialog_accept'"
      variant="primary"
      class="nes-mr-3"
      type="button"
      (nesOnClick)="configureRoute()"
    >
      {{ "COMPOSE.ROUTE.BUTTON.CONFIGURE" | translate }}
    </nes-button>
    <nes-button
      [disabled]="routeLoading$ | async"
      [cypress]="'dialog_decline'"
      variant="tertiary"
      type="button"
      (click)="closeDialog()"
    >
      {{ "COMPOSE.ROUTE.BUTTON.CANCEL" | translate }}
    </nes-button>
  </div>
</nes-dialog>
